export function getNames(value) {
  return value
    .map(item => {
      return `${
        item.vaxiom_person.title ? item.vaxiom_person.title + ' ' : ''
      }${item.vaxiom_person.first_name} ${item.vaxiom_person.last_name}`
    })
    .join(', ')
}
